var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConsumers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_238_1506",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H32V32H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_238_1506)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7794 0.625009L18.7132 1.32001C18.6688 2.14745 18.7094 3.06126 19.202 3.76126C19.8782 4.60688 20.3714 5.61251 20.5369 6.67188C20.582 6.96063 20.6069 7.25438 20.6107 7.55001L20.6114 11.9381C20.6119 12.5825 20.11 13.0344 19.5263 13.045C18.9051 13.0569 18.3963 12.5319 18.3963 11.9101V11.5644C18.3963 12.2256 17.9063 12.6794 17.2744 12.6719C16.6657 12.6656 16.1814 12.1581 16.1814 11.55V11.0306C16.1814 11.3363 16.0575 11.6132 15.8569 11.8138C15.6563 12.0144 15.3795 12.1375 15.0738 12.1381C14.4619 12.1375 13.9663 11.6419 13.9663 11.0306V10.4225C13.9663 10.7281 13.8419 11.005 13.6414 11.205C13.4407 11.4056 13.1638 11.53 12.8582 11.53C12.2469 11.53 11.7507 11.0338 11.7507 10.4219V8.37501C11.7507 7.28688 12.0025 6.21313 12.4869 5.2382L13.3907 3.41807C13.5738 3.04876 13.6694 2.64188 13.6694 2.22938L13.5826 0.625009",
    stroke: "#212A37",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2618 17.6611H5.1233C4.27167 17.6611 3.5813 18.3514 3.5813 19.2031C3.5813 20.0547 4.27167 20.745 5.1233 20.745H26.8765C27.7281 20.745 28.4185 20.0547 28.4185 19.2031C28.4185 18.3514 27.7281 17.6611 26.8765 17.6611H18.7602",
    stroke: "#212A37",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2617 17.6611H6.88403L8.75666 10.8533C9.0241 9.88107 9.90816 9.20725 10.9165 9.20725H11.7506",
    stroke: "#212A37",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7603 17.6611H25.1695L23.2969 10.8533C23.0383 9.91307 22.2031 9.25207 21.2364 9.20944H20.6109",
    stroke: "#212A37",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.56201 20.745L7.25026 30.1231C7.3807 30.8478 8.01132 31.375 8.74764 31.375H23.2523C23.9885 31.375 24.6192 30.8478 24.7496 30.1231L26.4379 20.745H5.56201Z",
    stroke: "#212A37",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 27.5808C15.3063 27.5808 14.7439 27.0184 14.7439 26.3248V20.745H17.2561V26.3248C17.2561 27.0184 16.6938 27.5808 16 27.5808Z",
    stroke: "#212A37",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8371 27.5808C10.1434 27.5808 9.58105 27.0184 9.58105 26.3248V20.745H12.0932V26.3248C12.0932 27.0184 11.5309 27.5808 10.8371 27.5808Z",
    stroke: "#212A37",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1626 27.5808C20.4688 27.5808 19.9065 27.0184 19.9065 26.3248V20.745H22.4187V26.3248C22.4187 27.0184 21.8563 27.5808 21.1626 27.5808Z",
    stroke: "#212A37",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsumers);
export default __webpack_public_path__ + "static/media/consumers.2cc4bcc729684b8b4aa31c464c7b23a5.svg";
export { ForwardRef as ReactComponent };